// extracted by mini-css-extract-plugin
export default {"button":"Button_button__K7IUG","primary":"Button_primary__QftoB","secondary":"Button_secondary__Q1tZY","fullWidth":"Button_fullWidth__mu11C"};